import React, { FC, ReactElement } from 'react';

import { Container } from 'layout';
import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';

import './CustomBottomInfoBlock.scss';
import { IPropsCustomBottomInfoBlock } from './models';

const CustomBottomInfoBlock: FC<IPropsCustomBottomInfoBlock> = ({ data }): ReactElement | null => (
  <div data-test="CustomBottomInfoBlock" className="custom-bottom-info-block">
    <Container>
      <DangerouslySetInnerHtml className="custom-bottom-info-block-text" html={data.text} />
      <DangerouslySetInnerHtml
        className="custom-bottom-info-block-description"
        html={data.description}
      />
    </Container>
  </div>
);

export default CustomBottomInfoBlock;
